import { SelectOption } from '@qwealth/qdata';
import { immutablySwapItems } from 'data/helpers/data';
import { SELECTED_CONTACTS_KEY } from 'data/refData/localCache';

export const getPreviouslyCachedSelected = (): Array<SelectOption<string>> => {
  const rawCachedSelected = localStorage.getItem(SELECTED_CONTACTS_KEY);
  return rawCachedSelected ? JSON.parse(rawCachedSelected) : [];
}

function immutablyUpdateSelected(previouslySelectedValues: string[],
                                 selected: SelectOption<string>,
                                 updated: SelectOption<string>[]): SelectOption<string>[] {
  const index = previouslySelectedValues.indexOf(selected.value)
  if (index > -1) {
    return immutablySwapItems<SelectOption<string>>(updated, 0, index);
  } else {
    return [selected, ...updated];
  }
}

export const updateCachedOptions = (selected?: SelectOption<string> | SelectOption<string>[]): void => {
  if (selected) {
    const previouslySelected = getPreviouslyCachedSelected();
    const previouslySelectedValues = previouslySelected.map(s => s.value);
    let updated = [...previouslySelected];
    if ('length' in selected) {
      (selected as SelectOption<string>[]).forEach(s => {
        updated = immutablyUpdateSelected(previouslySelectedValues, s, updated);
      });
    } else if ('value' in selected) {
      updated = immutablyUpdateSelected(previouslySelectedValues, selected, updated);
    }
    localStorage.setItem(SELECTED_CONTACTS_KEY, JSON.stringify(updated));
  }
}
